<template>
  <ConfigProvider :use-id="useIdFunction">
    <NuxtLoadingIndicator color="#0048A6" :throttle="0" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <VueQueryDevtools />
    <ClientOnly>
      <CookieConsentBanner />
    </ClientOnly>
  </ConfigProvider>
</template>

<script setup lang="ts">
import { VueQueryDevtools } from "@tanstack/vue-query-devtools";
const useIdFunction = () => useId();
</script>
